__turbopack_context__.v({
  "arrow": "ScrollableList-module-scss-module__-pMKnG__arrow",
  "container": "ScrollableList-module-scss-module__-pMKnG__container",
  "item": "ScrollableList-module-scss-module__-pMKnG__item",
  "list": "ScrollableList-module-scss-module__-pMKnG__list",
  "wrapper": "ScrollableList-module-scss-module__-pMKnG__wrapper",
});
